import { Button, Card, Col, Input, Menu, Modal, PageHeader, Popover, Row, Table } from 'antd'
import moment from 'moment'
import 'moment-timezone'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom'
import { token } from '../../config'
import { apiClient } from '../../api'
import { SearchOutlined } from '@ant-design/icons'

moment.tz.setDefault('Asia/Bangkok')

const dateFormatDateTime = 'DD/MM/YYYY HH:mm'
const routes = [
  {
    path: 'bannerlist',
    breadcrumbName: 'News'
  }
]

function BannerList() {
  const [datas, setDatas] = useState([])
  const [search, setSearch] = useState('')

  const load = () => {
    apiClient
      .post(
        'api/Announcement/List',
        {
          Type: 'banner',
          Currentpage: 1,
          PerPage: 100,
          AccParent: 0
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-type': 'application/json; charset=UTF-8'
          }
        }
      )
      .then(result => {
        setDatas(result.data.AnnouncementsList)
        if (search) {
          const dt = result.data.AnnouncementsList
          setDatas(dt.filter(x => x.Topic.toLowerCase().includes(search.toLowerCase())))
        }
      })
  }

  const deleteClick = (id, topic) => {
    Modal.confirm({
      title: 'Delete News',
      content: topic,
      okText: 'Delete',
      cancelText: 'Cancel',
      icon: <i class="fa-solid fa-circle-exclamation text-danger"></i>,
      onOk() {
        apiClient
          .post(
            '/api/Announcement/DeleteByID',
            {
              uid: id
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
                'Content-type': 'application/json; charset=UTF-8'
              }
            }
          )
          .then(result => {
            if (result.data === 'deleted success') {
              Modal.success({
                title: 'Success',
                content: 'Deleted',
                okText: 'OK',
                icon: <i class="fa-solid fa-circle-check text-success"></i>,
                onOk() {
                  load()
                }
              })
            }
          })
      },
      onCancel() {
        console.log('Cancelled')
      },
      okButtonProps: {
        style: { margin: '0px 1rem' }
      },
      cancelButtonProps: {
        style: { margin: '0px 1rem' }
      }
    })
  }

  const isCustomImage = (icon) =>
    icon === "Ants_LINEOA" ||
    icon === "Ants_LON" ||
    icon === "Ants_MMS" ||
    icon === "Ants_SMS";

  const columns = [
    {
      title: 'Thumbnails',
      dataIndex: 'IconUrl',
      key: 'IconUrl',
      width: 200,
      render: text => (
        <img
          src={isCustomImage(text) ? `/img/vendors/news/${text}.jpg` : `api/Announcement/Image/${text}`}
          style={{ height: '80px', width: '80px', objectFit: 'cover' }}
        />
      )
    },
    {
      title: 'Topic',
      dataIndex: 'Topic',
      key: 'Topic',
      width: 300,
      render: text => (
        <div className="word-break" title={text}>
          {text}
        </div>
      ),
      sorter: (a, b) => {
        const nameA = a?.Topic || ''
        const nameB = b?.Topic || ''
        return nameA.localeCompare(nameB)
      },
      sortDirections: ['descend', 'ascend']
    },
    {
      title: 'Start-End',
      dataIndex: 'StartDateTime',
      key: 'StartDateTime',
      width: 200,
      render: (text, x) => (
        <>
          <div>
            {!x.IsDefault ? moment(x.StartDatetime).format(dateFormatDateTime) : 'Always Display'}
          </div>
          <div>{!x.IsDefault ? moment(x.EndDatetime).format(dateFormatDateTime) : ''}</div>
        </>
      ),
      sorter: (a, b) => new Date(a.StartDatetime) - new Date(b.StartDatetime),
      sortDirections: ['descend', 'ascend']
    },
    {
      title: 'Status',
      dataIndex: 'Status',
      key: 'Status',
      width: 200,
      render: text => (
        <div className={`${text == 'active' ? 'badge-active' : 'badge-inactive'} text-center`}>
          {text == 'active' ? 'Active' : 'Inactive'}
        </div>
      ),
      sorter: (a, b) => (a.Status == 'active' ? 1 : 2) - (b.Status == 'active' ? 1 : 2),
      sortDirections: ['descend', 'ascend']
    },
    {
      title: 'Action',
      dataIndex: 'Action',
      key: 'Action',
      width: 150,
      render: (text, x) => (
        <>
          <Popover
            placement="bottomRight"
            content={
              <Menu mode="vertical">
                <Menu.Item
                  key="2"
                  style={{ borderBottom: '1px solid #7b7b7b' }}
                  data-toggle="modal"
                  data-target="#ModalEdit"
                >
                  <Link to={`/home/bannerlists/create?id=${x.Id}`}>
                    <span className="fa fa-pencil-square-o ants-gray size14"></span>&nbsp;&nbsp;
                    Edit
                  </Link>
                </Menu.Item>

                <Menu.Item key="3" onClick={() => deleteClick(x.Id, x.Topic)}>
                  <span className="fa fa-trash-o ants-gray size14"></span>&nbsp;&nbsp; Delete
                </Menu.Item>
              </Menu>
            }
            trigger="click"
          >
            <span
              className="fa fa-ellipsis-v"
              style={{ cursor: 'pointer', width: 30, textAlign: 'center' }}
            ></span>
          </Popover>
        </>
      )
    }
  ]

  useEffect(() => {
    load()
  }, [])
  return (
    <div className="animated fadeIn">
      <PageHeader breadcrumb={{ routes }}>
        <Row gutter={8} type="flex" justify="end">
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <div style={{ textAlign: 'right' }}>
              <Link to={'/home/bannerlists/create'}>
                <Button type="primary" style={{ marginRight: 8 }}>
                  <span className="fa fa-plus-circle"></span> &nbsp;&nbsp; New
                </Button>
              </Link>
            </div>
          </Col>
        </Row>
      </PageHeader>
      <div className="content containner">
        <Card>
          <div className="row">
            <div className="col-4">
              <Input placeholder="Search" onChange={event => setSearch(event.target.value)} />
            </div>
            <div className="col-8">
              <Button onClick={load}>
                <SearchOutlined /> Search
              </Button>
            </div>
          </div>
          <Table
            columns={columns}
            dataSource={datas}
            className="table-ants"
            tableLayout="fixed"
            pagination={{
              defaultPageSize: 10,
              pageSizeOptions: ['10', '20', '50', '100'],
              showSizeChanger: true,
              showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
            }}
          />
        </Card>
      </div>
    </div>
  )
}

export default BannerList